@if (healthAssessmentGridData !== null) {
  <ppl-accordion title="Health Assessments" [isOpen]="true">
    <div class="ant-row" style="justify-content: center">
      <div class="ant-col-24">
        <ppl-list-table
          [disableSort]="true"
          [disableSearch]="true"
          [enableActions]="true"
          [data]="healthAssessmentGridData"
          [actionButtons]="actionButtons"
          (gridAction)="action($event)"
          [disableSelection]="true"
          [cols]="cols"
          [gridTitle]="false"
          [pagination]="false"
        ></ppl-list-table>
      </div>
    </div>
  </ppl-accordion>
}
